export const settingKeys = {
  currentBookId: "currentBookId",
  currentChapterId: "currentChapterId",
  currentChapterPlayedTime: "currentChapterPlayedTime",
  playedTime: "playedTime",
  defaultChapterSort: "defaultChapterSort",
};